import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, Snackbar, Alert, CircularProgress, Grid, Typography, Box } from '@mui/material';


const API_URL = process.env.REACT_APP_API_URL;



const OTPValidationRequestUser = ({ sessionId}) => {
  const [otp, setOtp] = useState('');
  const [validationStatus, setValidationStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check initial validation status when component loads
    checkValidationStatus();
  }, []);

  const checkValidationStatus = async () => {
    try {
      // Send the post_id and user_id in the request body
      const response = await axios.post(`${API_URL}/api/booking-status-request-user/`, {
        session_id: sessionId,
        // user_id: userId
      });
  
      // If the response contains validation status
      if (response.data.validation === 'success') {
        setValidationStatus('success');
        setMessage('OTP has already been validated!');
        setOpen(true);
      }
    } catch (error) {
      console.log('Error fetching validation status', error);
      // If the API response has an error
      if (error.response) {
        setMessage(error.response.data.error || 'Something went wrong');
        setOpen(true);
      }
    }
  };

  const handleOtpSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${API_URL}/validate-otp-request-user/`, {
        session_id: sessionId,
        // user_id: userId,
        otp: otp,
      });

      if (response.status === 200) {
        setValidationStatus('success');
        setMessage(response.data.message);
        setOpen(true);
      }
    } catch (error) {
      setValidationStatus('failed');
      setMessage(error.response?.data?.message || 'Something went wrong');
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '30vh', padding: { xs: 2, sm: 3, md: 4 }, backgroundColor: '#1111' }}>
      <Grid item xs={12} sm={8} md={6} sx={{ backgroundColor: '#3333', padding: 4, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', textAlign: 'center', color: '#ecf0f1', letterSpacing: 4 }}>
          OTP Validation
        </Typography>

        {validationStatus === 'success' ? (
          <Box sx={{ textAlign: 'center', marginTop: 3, letterSpacing: 3 }}>
            <Typography variant="h6" color="success.main">
              OTP has been successfully validated!
            </Typography>
          </Box>
        ) : (
          <Box sx={{ marginTop: 3 }}>
            <TextField
              label="Enter OTP"
              variant="outlined"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              fullWidth
              helperText="Please enter the OTP given during the session."
              sx={{
                marginBottom: 2,
                letterSpacing: 3,
                '& .MuiInputLabel-root': { color: '#ecf0f1' }, // Label color
                '& .MuiOutlinedInput-root': { color: '#ecf0f1', borderColor: '#7f8c8d' },
                '& .MuiOutlinedInput-root.Mui-focused': { borderColor: '#1E90FF' },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleOtpSubmit}
              disabled={isLoading}
              fullWidth
              sx={{
                marginTop: 2,
                padding: '0.75rem',
                textTransform: 'none',
                borderRadius: 3,
                letterSpacing: 3,
                boxShadow: 2,
                '&:hover': {
                  backgroundColor: '#1E90FF',
                },
              }}
            >
              {isLoading ? <CircularProgress size={24} /> : 'Validate OTP'}
            </Button>
          </Box>
        )}

        <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={validationStatus === 'success' ? 'success' : 'error'} sx={{ backgroundColor: validationStatus === 'success' ? '#2ecc71' : '#e74c3c', color: '#fff', letterSpacing: 4 }}>
            {message}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
};

export default OTPValidationRequestUser;
